$(document).on('ajax:error', function(event, xhr, status, error) {
  return alert('Sorry, something went wrong\n(' + error + ')');
});
